import React from 'react'
import { DrawerProps } from 'antd/lib/drawer'
import { WrapDrawer, WrapChildren, WrapContent, WrapFooter } from './style'

function Drawer({
  children,
  destroyOnClose = true,
  footer = null,
  placement = 'right',
  ...props
}: DrawerProps & {
  children: any
  footer?: any
}) {
  return (
    <WrapDrawer
      {...props}
      bodyStyle={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        padding: 0,
        overflow: 'auto'
      }}
      destroyOnClose={destroyOnClose}
      headerStyle={{
        display: 'flex',
        borderBottom: '1px solid rgb(233, 233, 233)',
        padding: '10px 16px'
      }}
      placement={placement}
    >
      <WrapChildren>
        <WrapContent>{children}</WrapContent>
      </WrapChildren>
      {footer && <WrapFooter>{footer}</WrapFooter>}
    </WrapDrawer>
  )
}

export default Drawer
